import React, { useState } from "react";
import * as Sentry from "@sentry/browser";
import Api from "../../../Api";
import Icon from "../../Utils/Icon";
import classes from "./styles.module.css";

function emptyForm(payoutType) {
    return {
        merchantUuid: "",
        type: payoutType,
        amount: "",
        fullName: "",
        externalReference: "",
        description: "",
        cardPan: "",
        phone: "",
        bankMemberId: "",
        bankName: "",
    };
}

export default function CrmPayoutCreateModal(props) {
    var token = props.token;
    var payoutType = props.payoutType || "card";
    var isSbp = payoutType === "sbp";
    var merchants = props.merchants || [];
    var _form = useState(emptyForm(payoutType));
    var form = _form[0];
    var setForm = _form[1];
    var _error = useState("");
    var error = _error[0];
    var setError = _error[1];
    var _saving = useState(false);
    var saving = _saving[0];
    var setSaving = _saving[1];

    function change(name, value) {
        setForm(Object.assign({}, form, { [name]: value }));
    }

    function validate() {
        if (!form.merchantUuid) return "Выберите мерчанта";
        if (!form.amount || Number(form.amount) <= 0) return "Укажите положительную сумму";
        if (form.externalReference.length > 64) return "PayCrmID должен быть не длиннее 64 символов";
        if (isSbp) {
            if (!form.phone.trim()) return "Укажите телефон получателя";
            if (!form.bankMemberId.trim() && !form.bankName.trim()) {
                return "Укажите код НСПК или название банка";
            }
            if (form.bankMemberId.trim() && !/^\d{12}$/.test(form.bankMemberId.trim())) {
                return "Код НСПК должен состоять из 12 цифр";
            }
        } else {
            var pan = form.cardPan.replace(/\D/g, "");
            if (pan.length < 13 || pan.length > 19) return "Номер карты должен содержать от 13 до 19 цифр";
        }
        return "";
    }

    function submit() {
        var validationError = validate();
        if (validationError) {
            setError(validationError);
            return;
        }

        var payload = {
            merchantUuid: form.merchantUuid,
            type: payoutType,
            amount: Number(form.amount),
        };
        ["fullName", "externalReference", "description"].forEach(function (key) {
            if (form[key].trim()) payload[key] = form[key].trim();
        });
        if (isSbp) {
            payload.phone = form.phone.trim();
            if (form.bankMemberId.trim()) payload.bankMemberId = form.bankMemberId.trim();
            if (form.bankName.trim()) payload.bankName = form.bankName.trim();
        } else {
            payload.cardPan = form.cardPan.replace(/\D/g, "");
        }

        setSaving(true);
        setError("");
        new Api({ token: token }).createCrmPayoutRequest(payload).then(function (response) {
            setSaving(false);
            if (props.onCreated) props.onCreated(response.request);
            if (props.onMessage) {
                props.onMessage({ type: "success", message: "CRM-заявка создана" });
            }
        }).catch(function (e) {
            Sentry.captureException(e);
            var message = (e.response && e.response.data && e.response.data.message) || e.message || "Ошибка создания";
            setError(message);
            setSaving(false);
        });
    }

    return (
        <div className={classes.Backdrop} onClick={props.onClose}>
            <div className={classes.Modal} onClick={function (e) { e.stopPropagation(); }}>
                <div className={classes.Header}>
                    <h5>Создать CRM-заявку {isSbp ? "СБП" : "на карту"}</h5>
                    <button type="button" className={classes.Close} onClick={props.onClose}>
                        <Icon icon="close" size="15px" />
                    </button>
                </div>
                <div className={classes.Body}>
                    {error && <div className="alert alert-danger py-1 mb-2">{error}</div>}
                    <div className="form-group mb-2">
                        <label>Мерчант *</label>
                        <select className="form-control" value={form.merchantUuid} onChange={function (e) { change("merchantUuid", e.target.value); }}>
                            <option value="">-- Выберите --</option>
                            {merchants.map(function (merchant) {
                                return <option key={merchant.uuid} value={merchant.uuid}>{merchant.displayName}</option>;
                            })}
                        </select>
                    </div>
                    <div className={classes.Grid}>
                        <div className="form-group mb-2">
                            <label>Сумма, ₽ *</label>
                            <input type="number" min="0.01" step="0.01" className="form-control" value={form.amount} onChange={function (e) { change("amount", e.target.value); }} />
                        </div>
                        <div className="form-group mb-2">
                            <label>ФИО</label>
                            <input type="text" maxLength="255" className="form-control" value={form.fullName} onChange={function (e) { change("fullName", e.target.value); }} placeholder="Необязательно" />
                        </div>
                    </div>
                    {isSbp ? (
                        <div>
                            <div className="form-group mb-2">
                                <label>Телефон *</label>
                                <input type="text" className="form-control" value={form.phone} onChange={function (e) { change("phone", e.target.value); }} placeholder="9101234567" />
                            </div>
                            <div className={classes.Grid}>
                                <div className="form-group mb-2">
                                    <label>Код НСПК</label>
                                    <input type="text" maxLength="12" className="form-control" value={form.bankMemberId} onChange={function (e) { change("bankMemberId", e.target.value.replace(/\D/g, "")); }} placeholder="100000000111" />
                                </div>
                                <div className="form-group mb-2">
                                    <label>Название банка</label>
                                    <input type="text" className="form-control" value={form.bankName} onChange={function (e) { change("bankName", e.target.value); }} placeholder="Можно вместо кода" />
                                </div>
                            </div>
                            <small className="text-muted">Достаточно заполнить код НСПК или название банка. Если заполнены оба, они должны соответствовать друг другу.</small>
                        </div>
                    ) : (
                        <div className="form-group mb-2">
                            <label>Номер карты *</label>
                            <input type="text" maxLength="23" className="form-control" value={form.cardPan} onChange={function (e) { change("cardPan", e.target.value); }} placeholder="Номер без маски" />
                        </div>
                    )}
                    <div className="form-group mt-2 mb-2">
                        <label>PayCrmID / внешний ID</label>
                        <input type="text" maxLength="64" className="form-control" value={form.externalReference} onChange={function (e) { change("externalReference", e.target.value); }} placeholder="Необязательно, до 64 символов" />
                    </div>
                    <div className="form-group mb-0">
                        <label>Описание</label>
                        <input type="text" className="form-control" value={form.description} onChange={function (e) { change("description", e.target.value); }} placeholder="Необязательно" />
                    </div>
                </div>
                <div className={classes.Footer}>
                    <button type="button" className="btn btn-secondary" onClick={props.onClose}>Отмена</button>
                    <button type="button" className="btn btn-success" disabled={saving} onClick={submit}>
                        {saving ? "Создание..." : "Создать заявку"}
                    </button>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmPayoutCreateModal/index.js